/** @file Decides where animatable panel edits land: setup values, or keys at the playhead frame. */
import type { Doc } from '@pose2d/format/types';
import type { PlayheadSlice, ToolSlice } from '../../stores/types';
import type { EditTarget } from './rigView';

/** Keys at the (rounded, non-negative) playhead frame in Animate mode while an animation of `doc` is open; else setup. */
export function editTarget(mode: ToolSlice['mode'], playhead: Pick<PlayheadSlice, 'animation' | 'frame'>, doc: Doc): EditTarget {
  const { animation } = playhead;
  if (mode !== 'animate' || animation === null || !Object.hasOwn(doc.animations, animation)) return { kind: 'setup' };
  return { kind: 'key', animation, frame: Math.max(0, Math.round(playhead.frame)) };
}
